const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;
const MINUTES_PER_WEEK = 7 * MINUTES_PER_DAY;
const MINUTES_PER_MONTH = 30 * MINUTES_PER_DAY;

const DURATION_UNITS = [
  { key: 'a', label: 'ay', minutes: MINUTES_PER_MONTH },
  { key: 'h', label: 'hafta', minutes: MINUTES_PER_WEEK },
  { key: 'g', label: 'gün', minutes: MINUTES_PER_DAY },
  { key: 's', label: 'saat', minutes: MINUTES_PER_HOUR },
  { key: 'd', label: 'dakika', minutes: 1 },
] as const;

type DurationUnitKey = (typeof DURATION_UNITS)[number]['key'];

const DURATION_UNIT_MAP = new Map<DurationUnitKey, number>(DURATION_UNITS.map((unit) => [unit.key, unit.minutes]));
const DURATION_PART_PATTERN = /^([1-9]\d*)([ahgsd])$/i;

export const ESTIMATED_DURATION_TOOLTIP_LINES = [
  'a = ay, h = hafta, g = gün, s = saat, d = dakika',
  'Örnek: 1a 1h 1g 10s 15d',
  'Boşlukla birden fazla parça yazabilirsiniz.',
  'Sistem kaydederken toplam dakikaya çevirir.',
];

export const ESTIMATED_DURATION_VALIDATION_MESSAGE =
  'Geçerli bir süre giriniz. Örnek: 1a 1h 1g 10s 15d';

export const parseEstimatedDurationInput = (text?: string | null): number | undefined => {
  const normalized = (text ?? '').trim();
  if (!normalized) {
    return undefined;
  }

  const parts = normalized.split(/\s+/).filter(Boolean);
  if (!parts.length) {
    return undefined;
  }

  return parts.reduce((total, part) => {
    const match = part.match(DURATION_PART_PATTERN);
    if (!match) {
      throw new Error(ESTIMATED_DURATION_VALIDATION_MESSAGE);
    }

    const value = Number(match[1]);
    const unit = match[2].toLowerCase() as DurationUnitKey;
    const unitMinutes = DURATION_UNIT_MAP.get(unit);

    if (!unitMinutes) {
      throw new Error(ESTIMATED_DURATION_VALIDATION_MESSAGE);
    }

    return total + value * unitMinutes;
  }, 0);
};

export const formatEstimatedDurationMinutes = (minutes?: number | null): string => {
  if (minutes === undefined || minutes === null || !Number.isFinite(minutes) || minutes <= 0) {
    return '';
  }

  let remaining = Math.trunc(minutes);
  const parts: string[] = [];

  DURATION_UNITS.forEach((unit) => {
    if (remaining < unit.minutes) {
      return;
    }
    const count = Math.floor(remaining / unit.minutes);
    if (count <= 0) {
      return;
    }
    parts.push(`${count}${unit.key}`);
    remaining -= count * unit.minutes;
  });

  return parts.join(' ');
};
